import React, { useReducer, createContext } from "react";

const initialState = {
  stsToken: {
    accessKeyId: "",
    secretAccessKey: "",
    sessionToken: "",
  },
  vehicleSimulatorSettings: {
    serialNo: localStorage.getItem("serialNo") || "",
    vehicleKey: localStorage.getItem("vehicleKey") || "",
    customer: localStorage.getItem("simulatorCustomer") || "",
  },
  liveTrackingSession: {
    enabled: false,
    sessionId: null,
  },
  valetMode: {
    enabled: false,
    maxSpeed: null,
    trunkLocked: false
  },
};

export const SimulatorContext = createContext(initialState);
export const DispatchContext = createContext(null);

export const ACTIONS = {
  UPDATE_STS_TOKEN: "UPDATE_STS_TOKEN",
  VEHICLE_SIMULATOR_SETTINGS: "VEHICLE_SIMULATOR_SETTINGS",
  UPDATE_LIVE_TRACKING: "UPDATE_LIVE_TRACKING",
  UPDATE_VALET_MODE: "UPDATE_VALET_MODE",
};

const reducer = (state, action) => {
  const { type = "", payload = {} } = action;

  switch (type) {
    case ACTIONS.UPDATE_STS_TOKEN:
      return {
        ...state,
        stsToken: payload,
      };
    case ACTIONS.VEHICLE_SIMULATOR_SETTINGS:
      return {
        ...state,
        vehicleSimulatorSettings: {
          serialNo: payload?.serialNo,
          vehicleKey: payload?.vehicleKey,
          customer: payload?.customer,
        },
      };
    case ACTIONS.UPDATE_LIVE_TRACKING:
      return {
        ...state,
        liveTrackingSession: {
          ...state.liveTrackingSession,
          ...payload,
        },
      };
    case ACTIONS.UPDATE_VALET_MODE:
      return {
        ...state,
        valetMode: {
          ...state.valetMode,
          ...payload,
        },
      };
    default:
      return state;
  }
};

export const SimulatorProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <SimulatorContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </SimulatorContext.Provider>
  );
};
